import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { SalesOrderNotes } from "../models/orders/salesOrderNotes";

@Injectable({
  providedIn: "root",
})
export class OrderNotesSidebarService {
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";
  constructor(private _http: HttpClient) {}

  AddSalesOrderNotes(
    payload: SalesOrderNotes
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.saleOrderManagementBaseURL + "/AddSalesOrderNotes",
      payload
    );
  }

  getAllLinePoNumber(
    saleOrderId: string
  ): Observable<GenericResponseDto<string[]>> {
    return this._http.get<GenericResponseDto<string[]>>(
      this.saleOrderManagementBaseURL +
        `/GetPurchaseOrderIdOfSalesOrder?SaleOrderId=` +
        saleOrderId
    );
  }

  deleteSalesOrderNotes(
    payload: number[]
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.saleOrderManagementBaseURL + "/DeleteSalesOrderNotes",
      payload
    );
  }
}
